import { errorTextColor, missingTextColor, successTextColor, warningTextColor } from '../../common/constants';
import* as d3 from 'd3';

import { ResultsStatus } from '../../models';

export const resultsStatusScale = d3.scale.ordinal<ResultsStatus, string>()
    .domain([ResultsStatus.Ok, ResultsStatus.Warning, ResultsStatus.Error, ResultsStatus.Unknown])
    .range([successTextColor, warningTextColor, errorTextColor, missingTextColor]);